import styles from './ServiceCard.module.css';

export default function ServiceCard({ title, description, icon }) {
     const Icon = icon;
    return (
        <div className={styles.ServiceCard}>
            <div className={styles.ServiceCardIconWrapper}>
                <Icon className={styles.ServiceCardIcon} />
            </div>
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    );
}
